import { FormLabel, TextInput } from '@smartsheet/lodestar-core';
import React, { useState } from 'react';

export type ValidatorFn = (value?: any) => string;

export interface InputTextProps {
  id: string;
  value: string;
  readonly: boolean;
  onChange: any;
  multiline?: string;
  label: string;
  title: string;
  validator: ValidatorFn;
}

const emptyFn = (): void => {}; //eslint-disable-line @typescript-eslint/no-empty-function

export const ErrorMessageInputText = ({
  id,
  value,
  label,
  title,
  readonly,
  onChange,
  validator,
}: InputTextProps) => {
  const [error, setError] = useState('');
  const [originalValue] = useState(value);

  const onChangeOverride = (value: string) => {
    const originalOnChange = onChange || emptyFn;
    originalOnChange(value);

    // The component is used in FormJS.
    // The problem is that FormJS accepts a map of components capable of handling certain
    // input parameter types. This component is set to handle STRING parameters.
    // However there are could be many different STRING input parameters but we want
    // the non-duplicate check to be active only when editing form.state param.
    if (id !== 'form.state') {
      return;
    }

    if (!value) {
      setError(`${label} is required.`);
    } else {
      const errorMessage = validator(value);
      if (value != originalValue && errorMessage) {
        setError(`${errorMessage}`);
      } else {
        setError('');
      }
    }
  };

  return (
    <FormLabel
      id={id}
      label={label}
      description={title}
      validationMessage={error}
      validationState={error && error.length ? 'error' : undefined}
    >
      {inputProps => (
        <TextInput
          value={value}
          onChange={onChangeOverride}
          readOnly={readonly}
          validationState={error && error.length ? 'error' : undefined}
          //TODO base this on whether an input is marked as optional or not
          aria-required={id === 'form.state'}
          aria-invalid={(error && error.length > 0) || undefined}
          {...inputProps}
        />
      )}
    </FormLabel>
  );
};
